import { UpdateProfileForm } from '../types';

import { axios } from '@/lib/axios';

export const APIupdateProfile = (data: UpdateProfileForm): Promise<void> => {
    return axios.put('/auth/profile', { data });
};
